import { FC, useCallback } from 'react';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import useGoogleTranslate, { LANGUAGES } from 'src/hooks/useGoogleTranslate';

interface LanguageMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

const LanguageMenu: FC<LanguageMenuProps> = ({ anchorEl, onClose }) => {
  const { currentLang, selectLanguage } = useGoogleTranslate();

  const handleSelectLanguage = useCallback(
    (langCode: string) => {
      onClose();
      selectLanguage(langCode);
    },
    [onClose, selectLanguage]
  );

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      slotProps={{
        paper: {
          sx: { maxHeight: 300 },
        },
      }}
    >
      {LANGUAGES.map((lang) => (
        <MenuItem
          className="notranslate"
          key={lang.code}
          onClick={() => handleSelectLanguage(lang.code)}
          selected={currentLang === lang.code}
        >
          <ListItemText primary={lang.label} />
          {currentLang === lang.code && (
            <ListItemIcon sx={{ minWidth: 'auto', ml: 1 }}>
              <CheckIcon fontSize="small" color="primary" />
            </ListItemIcon>
          )}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default LanguageMenu;
